import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HelpHeaderComponent } from './help-header/help-header.component';
import { HelpMainSecComponent } from './help-main-sec/help-main-sec.component';
import { HelpSideBarComponent } from './help-side-bar/help-side-bar.component';
import { HelpTopBarComponent } from './help-top-bar/help-top-bar.component';

@Component({
  selector: 'app-helpfile',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HelpTopBarComponent,
    HelpMainSecComponent,
    HelpSideBarComponent,
    HelpHeaderComponent
  ],
  templateUrl: './helpfile.component.html',
  styleUrl: './helpfile.component.scss'
})
export class HelpfileComponent {
  sidebarOpen = true;

  onToggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
  }
}
